import { CommonModule } from "@angular/common";
import { NgModule, Optional, SkipSelf } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { ChangePasswordComponent } from "@app/core/change-password/change-password.component";
import { ContactComponent } from "@app/core/contact/contact.component";
import { CookieComponent } from "@app/core/cookie/cookie.component";
import { CoreRouterModule } from "@app/core/core.routing";
import { FooterComponent } from "@app/core/footer/footer.component";
import { HeaderComponent } from "@app/core/header/header.component";
import { CompanyComponent } from "@app/core/home/company/company.component";
import { HomeComponent } from "@app/core/home/home.component";
import { WhySignUpComponent } from "@app/core/home/why-sign-up/why-sign-up.component";
import { MainComponent } from "@app/core/main.component";
import { PartnerComponent } from "@app/core/partner/partner.component";
import { PasswordRecoveryComponent } from "@app/core/password-recovery/password-recovery.component";
import { PaymentSuccessComponent } from "@app/core/payment-success/payment-success.component";
import { PrivacyComponent } from "@app/core/privacy/privacy.component";
import { RegistrationComponent } from "@app/core/registration/registration.component";
import { ServerMaintenanceComponent } from "@app/core/server-maintenance/server-maintenance.component";
import { SpinnerModule } from "@app/core/spinner/spinner.module";
import { UserSignupComponent } from "@app/core/user-signup/user-signup.component";
import { FormxInputComponent } from "@shared/component/formx-input/formx-input.component";
import { AdminService } from "@shared/services/admin/admin.service";
import { AlertMessageService } from "@shared/services/alert-message/alert-message.service";
import { AuctionService } from "@shared/services/auction/auction.service";
import { CodeTableService } from "@shared/services/code-table/code-table.service";
import { DealerService } from "@shared/services/dealers/dealer.service";
import { FileService } from "@shared/services/file/file.service";
import { MqttService } from "@shared/services/mqtt/mqtt.service";
import { OpenApiService } from "@shared/services/open/open-api.service";
import { ScriptService } from "@shared/services/script.service";
import { ShowcaseService } from "@shared/services/showcase/showcase.service";
import { SnackbarService } from "@shared/services/snackbar.service";
import { SnackBarComponent } from "@shared/services/snackbar/snackbar.component";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { TemplateService } from "@shared/services/template/template.service";
import { UserApiService } from "@shared/services/users/userApi.service";
import { UsersService } from "@shared/services/users/users.service";
import { VehicleService } from "@shared/services/vehicle/vehicle.service";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { SharedModule } from "@shared/shared.module";

@NgModule({
	declarations: [
		PartnerComponent,
		FooterComponent,
		HeaderComponent,
		HomeComponent,
		RegistrationComponent,
		PrivacyComponent,
		MainComponent,
		PasswordRecoveryComponent,
		CookieComponent,
		ChangePasswordComponent,
		UserSignupComponent,
		CompanyComponent,
		WhySignUpComponent,
		ContactComponent,
		ServerMaintenanceComponent,
		PaymentSuccessComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		CoreRouterModule,
		SpinnerModule,
		ReactiveFormsModule,
		FormxInputComponent,
		SnackBarComponent
	],
	exports: [
		SpinnerModule
	],
	providers: [
		UsersService,
		OpenApiService,
		FileService,
		DealerService,
		MqttService,
		VehicleService,
		ShowcaseService,
		StorageManagerService,
		AlertMessageService,
		CodeTableService,
		ShowcaseService,
		UserApiService,
		AdminService,
		WcmService,
		ScriptService,
		TemplateService,
		AuctionService,
		SnackbarService
	],
	bootstrap: [MainComponent]
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) { }
}
